import { cloneDeep } from 'lodash';

import { actions } from './actions';
import { mutations } from './mutations';

export const defaultState = {
    formData: {
        name: '',
        phone: '',
        country: 'United States',
        addressLines: '',
        city: '',
        state: '',
        postalCode: '',
    },
};

export const vmkey_store = {
    namespaced: true,
    state: cloneDeep(defaultState),
    actions,
    mutations,
};
